/**
 * @generated SignedSource<<d93608aa1e24480a42e1683b47e0d06c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddAnswerInput = {
  clientMutationId?: string | null;
  elementId: string;
  other: boolean;
  position?: number | null;
  terminate: boolean;
};
export type ActiveElementContent_addAnswer_Mutation$variables = {
  input: AddAnswerInput;
};
export type ActiveElementContent_addAnswer_Mutation$data = {
  readonly addAnswer: {
    readonly element: {
      readonly answers: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly dbId: string;
            readonly exclusive: boolean;
            readonly id: string;
            readonly other: boolean;
            readonly position: number;
            readonly quota: number | null;
            readonly terminate: boolean;
            readonly text: string | null;
          } | null;
        } | null>;
      };
      readonly id: string;
    } | null;
  } | null;
};
export type ActiveElementContent_addAnswer_Mutation = {
  response: ActiveElementContent_addAnswer_Mutation$data;
  variables: ActiveElementContent_addAnswer_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddAnswerPayload",
    "kind": "LinkedField",
    "name": "addAnswer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ElementNode",
        "kind": "LinkedField",
        "name": "element",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AnswerNodeConnection",
            "kind": "LinkedField",
            "name": "answers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AnswerNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AnswerNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dbId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "text",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "terminate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "quota",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "other",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "position",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "exclusive",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ActiveElementContent_addAnswer_Mutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ActiveElementContent_addAnswer_Mutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "455e9fc0b241d8099de0b075676b1ae9",
    "id": null,
    "metadata": {},
    "name": "ActiveElementContent_addAnswer_Mutation",
    "operationKind": "mutation",
    "text": "mutation ActiveElementContent_addAnswer_Mutation(\n  $input: AddAnswerInput!\n) {\n  addAnswer(input: $input) {\n    element {\n      id\n      answers {\n        edges {\n          node {\n            id\n            dbId\n            text\n            terminate\n            quota\n            other\n            position\n            exclusive\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a541fb128e5d7ebaa14d6a4b28fe500b";

export default node;
